import { render, staticRenderFns } from "./HealthProfessionalForm.vue?vue&type=template&id=a22a8378&scoped=true&v-if=internal&"
import script from "./HealthProfessionalForm.vue?vue&type=script&lang=ts&"
export * from "./HealthProfessionalForm.vue?vue&type=script&lang=ts&"
import style0 from "./HealthProfessionalForm.vue?vue&type=style&index=0&id=a22a8378&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22a8378",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VSelect,VSwitch,VTextField})
